var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var EmailMd = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--medium", className].filter(Boolean).join(" "),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 3h-9Zm-.536 1.098C3.131 4.035 3.311 4 3.5 4h9c.189 0 .37.035.535.098L8 7.875 2.964 4.098Zm-.774.67c-.12.216-.19.466-.19.732v5A1.5 1.5 0 0 0 3.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-5c0-.266-.07-.516-.19-.732L8.3 8.9a.5.5 0 0 1-.6 0L2.19 4.768Z",
    fill: "currentColor"
  }));
});
EmailMd.displayName = "EmailMd";
export default EmailMd;